module.exports = __webpack_public_path__ + "img/headwear.0d6a36fe.jpg";